<template>
  <div class="row blaLingronContainer">
    <ProgressBar
      :current-position="currentPosition"
      :max-position="maxPosition"
      :fixed-header="true"
    />
    <div class="col-10 offset-1">
      <div class="row my-5">
        <div class="col-2 text-right">
          <img
            :src="require('@/assets/img/exclamation_mark_icon.png')"
            alt="exclamation_mark_icon"
            class="blaExlaminationIcon"
          />
        </div>
        <div class="col-10 blaLingronTitle">
          Hallgasd meg a hanganyagot, majd koppints a helyes szövegre.
        </div>
      </div>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated slideInRight"
        leave-active-class="animated slideOutLeft"
        duration="750"
      >
        <div v-show="showLingrons" class="row mt-5 mb-2">
          <div class="col-12 mt-3 text-center">
            <img
              :src="require('@/assets/img/bla_play_button.png')"
              alt="play_button"
              class="blaLingronPlayButton clickable"
              :class="{ pulsePlayButton: playedNow }"
              @click="playSound(lingron.file)"
            />
          </div>
        </div>
      </transition>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated slideInRight"
        leave-active-class="animated slideOutLeft"
        duration="750"
      >
        <div
          v-show="showLingrons"
          class="row mt-5 mb-2 p-0 text-center align-center"
        >
          <div class="col-12 col-lg-6">
            <div
              v-if="lingron.other_lang && lingron.id % 2 === 0"
              class="blaLingronTextBox"
              @click="goodAnswer"
              :class="{
                blaLingronTextBoxSuccess: showGoodAnswer,
              }"
            >
              <div v-if="showMainLangGood" class="row align-center text-center">
                <!--<div class="col-2 text-right">-->
                <!--  <i class="fas fa-check"></i>-->
                <!--</div>-->
                <!--<div class="col-10 text-center">-->
                <div v-if="lingron && lingron.main_lang" class="col-12">
                  {{ lingron.main_lang }}
                </div>
              </div>
              <div v-else class="row align-center text-center">
                <!--<div v-if="showGoodAnswer" class="col-2 text-right">-->
                <!--  <i class="fas fa-check"></i>-->
                <!--</div>-->
                <!--<div :class="[showGoodAnswer ? 'col-10 text-center' : 'col-12']">-->
                <div
                  v-if="lingron && lingron.other_lang"
                  :class="[showGoodAnswer ? 'col-12' : 'col-12']"
                >
                  {{ lingron.other_lang }}
                </div>
              </div>
            </div>
            <div
              v-else
              class="blaLingronTextBox"
              @click="wrongAnswer"
              :class="{
                blaLingronTextBoxError: showWrongAnswer,
              }"
            >
              <div
                v-if="showMainLangWrong && lingron.wrongLingron"
                class="text-center"
              >
                {{ lingron.wrongLingron.main_lang }}
              </div>
              <div v-else class="text-center">
                {{ lingron.wrongLingron.other_lang }}
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mt-4 mt-sm-2 mt-md-2 mt-lg-0">
            <div
              v-if="lingron.other_lang && lingron.id % 2 === 0"
              class="blaLingronTextBox"
              @click="wrongAnswer"
              :class="{
                blaLingronTextBoxError: showWrongAnswer,
              }"
            >
              <div
                v-if="showMainLangWrong && lingron.wrongLingron"
                class="text-center"
              >
                {{ lingron.wrongLingron.main_lang }}
              </div>
              <div v-else class="text-center">
                {{ lingron.wrongLingron.other_lang }}
              </div>
            </div>
            <div
              v-else
              class="blaLingronTextBox"
              @click="goodAnswer"
              :class="{
                blaLingronTextBoxSuccess: showGoodAnswer,
              }"
            >
              <div v-if="showMainLangGood" class="row text-center align-center">
                <!--  div class="col-2 text-right">-->
                <!--  <i class="fas fa-check"></i>-->
                <!--</div>-->
                <!--<div class="col-10 text-center"><-->
                <div v-if="lingron && lingron.main_lang" class="col-12">
                  {{ lingron.main_lang }}
                </div>
              </div>
              <div v-else class="row text-center align-center">
                <!--<div v-if="showGoodAnswer" class="col-2 text-right">-->
                <!--  <i class="fas fa-check"></i>-->
                <!--</div>-->
                <!--<div :class="[showGoodAnswer ? 'col-10 text-center' : 'col-12']">-->
                <div
                  v-if="lingron && lingron.other_lang"
                  :class="[showGoodAnswer ? 'col-12' : 'col-12']"
                >
                  {{ lingron.other_lang }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated slideOutLeft"
        duration="750"
      >
        <div v-show="showNext" class="row mt-4 mb-2 mt-5 align-center">
          <div class="col-12 col-md-2 offset-md-5 text-center">
            <div class="blaLingronNextButton" @click="loadNext">Következő</div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { setTimeout } from "timers";
import { mapGetters } from "vuex";
import ProgressBar from "@/components/partials/ProgressBar";

export default {
  components: {
    ProgressBar,
  },
  data: function () {
    return {
      // lessonId: this.$route.params.lessonId, //For dev
      lessonId: this.$store.getters.currentLessonId,
      lingron: {},
      enableClick: false,
      lingronClick: false,
      soundFileDuration: 3000,
      playedNow: false,
      playedFile: "",
      currentPosition: 0,
      maxPosition: 0,
      mainWordShow: false,
      otherWordShow: true,
      showLingrons: false,
      showNext: false,
      showMainLangGood: false,
      showMainLangWrong: false,
      showGoodAnswer: false,
      showWrongAnswer: false,
      lastLingronId: this.$store.getters.lastLingronId,
      clickCounter: 0,
    };
  },
  methods: {
    getLingronData() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/lingron", {
          token: this.$store.getters.getToken,
          lessonId: this.$data.lessonId,
          lastLingronId: this.lastLingronId,
        })
        .then((response) => {
          // console.log("lingron - resp: ", response.data);
          this.lingron = response.data.lingron;
          this.currentPosition = response.data.currentPosition;
          this.maxPosition = response.data.maxPosition;
          this.clickCounter = 0;

          //Store last lingron ID
          this.$store.commit("updateLastLingronId", {
            lastLingronId: response.data.lingron.id,
          });

          //Store linfron last state
          this.$store.commit("updateLastLingron", {
            lastLingron: response.data.lingron.last,
          });

          //Show lingron default
          // this.showLingrons = true;
          this.lingronClick = false;

          let v = this;
          setTimeout(function () {
            v.showLingrons = true;
          }, 1000);
        })
        .catch((error) => {
          console.log("lingron - error: ", error);
        });
    },
    goodAnswer() {
      if (this.lingronClick) {
        if (this.enableClick) {
          this.showGoodAnswer = true;
          this.showWrongAnswer = false;
          this.enableClick = false;
          this.showNext = true;
          this.showMainLangGood = true;
          this.clickCounter++;
          this.playTheGoodAnswerSound(); //Play correct soundeffect

          //Add 3 point to earnedScores & 1 to goodAnswers at the first time
          if (this.clickCounter < 2) {
            this.$store.dispatch("goodAnswerEarned");
          }
        } else {
          this.showMainLangGood = !this.showMainLangGood;
        }
      }
    },
    wrongAnswer() {
      if (this.lingronClick) {
        if (this.enableClick) {
          this.playTheWrongAnswerSound();
          this.showGoodAnswer = false;
          this.showWrongAnswer = true;
          this.enableClick = false;
          this.showNext = false;
          this.showMainLangWrong = false;

          //Increase click counter
          this.clickCounter++;

          //Hide wrong answer
          let v = this;
          setTimeout(() => {
            v.showWrongAnswer = false;
            v.enableClick = true;
          }, 1500);
        } else {
          this.showMainLangWrong = !this.showMainLangWrong;
        }
      }
    },
    playTheWrongAnswerSound() {
      let sound = require("@/assets/sound/wrong_answer2.mp3");
      let audio = new Audio(sound);
      audio.volume = 0.2;
      audio.play();
    },
    playTheGoodAnswerSound() {
      let sound = require("@/assets/sound/correct_answer2.mp3");
      let audio = new Audio(sound);
      audio.volume = 0.2;
      audio.play();
    },
    playSound(file) {
      if (file) {
        //Play the audio file
        let sound =
          this.$store.getters.getApiUrl + "/uploads/sound/" + file.filename;

        //Create audio object
        let audio = new Audio(sound);
        let v = this;
        //Sound file duration
        // audio.addEventListener(
        //   "loadedmetadata",
        //   function() {
        //     v.soundFileDuration = audio.duration * 1000;
        //   },
        //   false
        // );

        audio.load();

        if (!this.playedNow) {
          this.playedNow = true;
          this.playedFile = audio;

          //Play sound
          audio.play();

          let v = this;
          setTimeout(function () {
            v.playedNow = false;
            v.voiceShow = false;
            v.showLingrons = true;
            v.lingronClick = true;
            v.enableClick = true;
          }, this.soundFileDuration);
        }
      }
    },
    stopSound() {
      if (this.playedFile !== null && this.isPlaying) {
        //Stop the audio file
        let audio = this.playedFile;
        audio.pause();
        this.playedFile = null;
      }
    },
    loadNext() {
      //Stop the played file if it is already playing
      this.stopSound();

      //reset all visibility variables
      this.resetAllVisibilityVariables();

      //If lingrons has minilingrons we load them
      if (this.lingron.mini_lingrons && this.lingron.mini_lingrons.length > 1) {
        //Store came from lingron page
        this.$store.commit("updateFromLingron", {
          fromLingron: true,
        });

        this.$router.push({
          name: "miniLingron",
          params: {
            lessonId: this.lingron.lesson_id,
            lingronId: this.lingron.id,
          },
        });
      } else {
        //Lingron does not have minilingron
        //Update the lastLingronId value
        this.lastLingronId = this.$store.getters.lastLingronId;

        //Load the next lingron
        this.getLingronData();
      }
    },
    resetAllVisibilityVariables() {
      this.showLingrons = false;
      this.showNext = false;
      this.showWrongAnswer = false;
      this.showGoodAnswer = false;
      this.enableClick = true;
      this.showMainLangWrong = false;
      this.showMainLangGood = false;
      this.enableClick = false;
    },
  },
  computed: {
    ...mapGetters["lastLingronId"],
  },
  mounted: function () {
    this.lastLingronId = this.$store.getters.lastLingronId;

    this.$store.commit("updateLastMiniLingronId", {
      lastMiniLingronId: null,
    });

    this.resetAllVisibilityVariables();
    this.getLingronData();
  },
};
</script>
